/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Projects_Delete_ConfirmInputs */

const cs_projects_delete_confirm = /** @type {(inputs: Projects_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Smazat projekt ${i?.name}?`)
};

const en_projects_delete_confirm = /** @type {(inputs: Projects_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete project ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "Delete project {name}?" |
*
* @param {Projects_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_delete_confirm = /** @type {((inputs: Projects_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_delete_confirm(inputs)
	return cs_projects_delete_confirm(inputs)
});